import {inject, customAttribute, DOM} from 'aurelia-framework';
import Inputmask from 'inputmask';

@customAttribute('input-mask')
@inject(DOM.Element)
export class InputMaskAttribute {
    private settings: any;

    constructor(private element: HTMLInputElement) {
        this.element = element;
    }

    bind(params) {

        switch (params.format) {

            case "twoDec" :
                this.settings = {
                    greedy: false,
                    alias: 'currency',
                    radixPoint: ',',
                    groupSeparator: ' ',
                    digits: 2,
                    autoGroup: true,
                    rightAlign: false,
                    prefix: ''
                };
                break;
            case "fourDec" :
                this.settings = {
                    greedy: false,
                    alias: 'currency',
                    radixPoint: ',',
                    groupSeparator: ' ',
                    digits: 4,
                    autoGroup: true,
                    rightAlign: false,
                    prefix: ''
                };
                break;
            case "zeroDec" :
                this.settings = {
                    greedy: false,
                    alias: 'currency',
                    radixPoint: ',',
                    groupSeparator: ' ',
                    digits: 0,
                    autoGroup: true,
                    rightAlign: false,
                    prefix: ''
                };
                break;
        }
    }


    attached(params) {
        if (this.settings) {
            const im = new Inputmask(this.settings);
            im.mask(this.element);
        }

    }


}
  

  